module.exports = __webpack_public_path__ + "img/ActiveCampaign.af7be6f3.png";